import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import anime from 'animejs/lib/anime.es.js';
import Swup from 'swup';
import SwupPreloadPlugin from '@swup/preload-plugin';
import SwupScriptsPlugin from '@swup/scripts-plugin';
import 'swiper/css/bundle';
import GLightbox from 'glightbox';
import Swiper, {Navigation, Autoplay, Mousewheel, EffectFade} from 'swiper';

Alpine.plugin(intersect);
window.Alpine = Alpine;
window.animateSVGStroke = animateSVGStroke;
window.homeAnimationComplete = false;
window.pathName = '';

// Swiper.use([Autoplay]);
Swiper.use([Mousewheel]);
// window.Swiper = Swiper;

const body = document.body;
const select = e => document.querySelector(e);
const selectAll = e => document.querySelectorAll(e);

const swup = new Swup({
    animationSelector: '[class*="page-transition-"]',
    plugins: [
        new SwupPreloadPlugin(),
        new SwupScriptsPlugin()
    ]
});

init();


window.Alpine = Alpine;
window.homeSliderInit = homeSliderInit;
Alpine.start();

function init() {
    window.Anime = anime;
    setMenuArrowState();
    homeLoader();
    hashChecker();
    lightboxInit();
    customCursor();
    addHoverEffectsToBardLinks();
    underlineLinks();
    footerAsterixAnimTrigger();
    footerGetInTouchAnimTrigger();
    drawSVG();
    teamNamer();
    homeSliderInit();
    // footerLoader();
}

function homeSliderInit() {

    if(window.homeSlider) {
        window.homeSlider.destroy();
    }

    if(document.querySelector('#swup').classList.contains('slug--home')) {
        // console.log(document.querySelector('.swiper-container'));

        window.homeSlider = new Swiper(document.querySelector('.swiper-container'), {
            modules: [Navigation, Autoplay, EffectFade],
            autoplay: {
                delay: 4500,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: document.querySelector('.slider--next'),
                prevEl: document.querySelector('.slider--previous'),
            },
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            speed: 1000,
            loop: true,
            on:
            {
                slideChangeTransitionStart: function () {
                    var swiper = this;
                    var logoColour = document.querySelector('.js-home-slider .swiper-slide-active').getAttribute('data-colour');
                    document.querySelector('#logo').classList.add('' + logoColour + '');
                    document.querySelector('#logotype').classList.add('' + logoColour + '');
                },
            },
        });
    }
}

function hashChecker() {
    if (window.location.hash) {
        window.setTimeout(() => {
            let scrollElement = document.querySelector(window.location.hash);
            scrollElement.scrollIntoView({
                behavior: 'smooth'
            });
        }, 1500)
    }
}

function setMenuArrowState() {
    if (window.location.pathname == '/projects') {
        document.querySelector('.project-link .circle').classList.remove('hidden');
        document.querySelector('.project-link .arrow').classList.add('hidden');
        document.querySelector('.studio-link .circle').classList.add('hidden');
        document.querySelector('.studio-link .arrow').classList.remove('hidden');
    } else if (window.location.pathname == '/studio') {
        document.querySelector('.project-link .circle').classList.add('hidden');
        document.querySelector('.project-link .arrow').classList.remove('hidden');
        document.querySelector('.studio-link .circle').classList.remove('hidden');
        document.querySelector('.studio-link .arrow').classList.add('hidden');
    } else {
        document.querySelector('.project-link .circle').classList.add('hidden');
        document.querySelector('.project-link .arrow').classList.remove('hidden');
        document.querySelector('.studio-link .circle').classList.add('hidden');
        document.querySelector('.studio-link .arrow').classList.remove('hidden');
    }
}

function addHoverEffectsToBardLinks() {
    const bardHoverElements = document.querySelectorAll('.cursorHover');

    if(bardHoverElements) {
        bardHoverElements.forEach((element) => {
            element.addEventListener('mouseover', () => {
                document.querySelector('.js-cursor').classList.add('hovering');
            });
            element.addEventListener('mouseleave', () => {
                document.querySelector('.js-cursor').classList.remove('hovering');
            });
        });
    }
}

swup.on('contentReplaced', function (event) {
    window.scrollTo(0, 0);
    init();
    lightboxInit();
    customCursor();
    underlineLinks();
});

swup.on('clickLink', function (event) {
    if(event.target.getAttribute("href")){
        let href = event.target.getAttribute("href");
        const paths = ['/projects', '/studio'];
        if (paths.includes(href)){
            if (href == window.location.pathname){
                history.back();
            } else {
                if(href == '/studio'){
                    document.body.classList.add('bg-grey-light');
                } else {
                    document.body.classList.remove('bg-grey-light');
                }
            }
        }
    }
    
    if (event.target.hash) {
            let scrollElement = document.querySelector(event.target.hash);
            let elementPadding = window.getComputedStyle(scrollElement, null).getPropertyValue('padding-top').replace("px", "");
            let scrollPosition = scrollElement.getBoundingClientRect().top + window.scrollY + parseInt(elementPadding);
            animateScrollTo(scrollPosition, 2000);
    }
});

swup.on('contentReplaced', function() {
    // if homepage, reload animation
    let logoAnimationWrapper = document.querySelector('.logo-animation-wrapper');
    let projectWrapper = document.querySelector('.project-wrapper');
    if(logoAnimationWrapper){
        window.homeAnimationComplete = false;
        logoAnimationWrapper.classList.remove('finished');
        homeLoader();
    }
    if(projectWrapper) {
        changeLogoColor();
    }
});

document.addEventListener('DOMContentLoaded', (event) => {
    changeLogoColor();
});

function changeLogoColor(){
    let projectWrapper = document.querySelector('.project-wrapper');
    if(projectWrapper) {
        var logoColour = projectWrapper.getAttribute('data-colour');
        document.querySelector('#logo').classList.add('' + logoColour + '');
        document.querySelector('#logotype').classList.add('' + logoColour + ''); 
    }
}


function animateScrollTo (to, duration) {
    const element = document.scrollingElement || document.documentElement;
    const start = element.scrollTop;
    const change = to - start;
    const startDate = +new Date();
    // t = current time
    // b = start value
    // c = change in value
    // d = duration
    const easeInOutQuad = (t, b, c, d) => {
      let t2 = t;
      t2 /= d / 2;
      if (t2 < 1) return (c / 2) * t2 * t2 + b;
      t2 -= 1;
      return (-c / 2) * (t2 * (t2 - 2) - 1) + b;
    };
    const easeInOutCubic = (t, b, c, d) => {
        t /= d/2;
        if (t < 1) return c/2*t*t*t + b;
        t -= 2;
        return c/2*(t*t*t + 2) + b;
    };
    const animateScroll = () => {
      const currentDate = +new Date();
      const currentTime = currentDate - startDate;
      element.scrollTop = parseInt(easeInOutCubic(currentTime, start, change, duration), 10);
      if (currentTime < duration) {
        requestAnimationFrame(animateScroll);
      } else {
        element.scrollTop = to;
      }
    };
    animateScroll();
  };

function lightboxInit() {

    if(document.querySelector('.glightbox')) {
        let lbTriggerLinks = document.querySelectorAll('.glightbox');

        lbTriggerLinks.forEach((trigger) => {
            trigger.addEventListener('click', (e) => {
                e.stopPropagation();
                e.preventDefault();

            })
        })

        let projectTitle = document.querySelector('#project-title').innerHTML;
        let currentSlideNum = 0;
        let totalSlideNum = 0;

        let slideCounterElement = undefined;

        const customLightboxHTML = `<div id="glightbox-body" class="glightbox-container">
            <div class="gloader visible"></div>
            <div class="goverlay"></div>
            <div class="gcontainer">
            <div id="glightbox-slider" class="gslider"></div>
            <div class="slider-bottom-bar"><span class="project-title">${ projectTitle }</span><span class="counter">1/10</span></div>
            <button class="gnext gbtn" tabindex="0" aria-label="Next" data-customattribute="example">{nextSVG}</button>
            <button class="gprev gbtn" tabindex="1" aria-label="Previous">{prevSVG}</button>
            <button class="gclose gbtn" tabindex="2" aria-label="Close">{closeSVG}</button>
        </div>
        </div>`;

        const lightbox = GLightbox({
            lightboxHTML: customLightboxHTML,
            touchNavigation: true,
            loop: true,
            skin: "ptid-lightbox clean",
            openEffect: "fade",
            closeEffect: "fade",
            closeButton: true,
            zoomable: false,
            videosWidth: '100%'
        });

        lightbox.on('open', () => {
            slideCounterElement = document.querySelector('.slider-bottom-bar .counter');
            let buttons = document.querySelectorAll('.gbtn');

            totalSlideNum = document.querySelectorAll('.gslide').length;
            slideCounterElement.innerHTML = '1/' + totalSlideNum;

            buttons.forEach((button) => {
                button.addEventListener('mouseover', () => {
                    document.querySelector('.js-cursor').classList.add('opacity-0');
                });

                button.addEventListener('mouseleave', () => {
                    document.querySelector('.js-cursor').classList.remove('opacity-0');
                });
            });

        });

        lightbox.on('slide_changed', () => {
            document.querySelectorAll('.gslide').forEach((slide, index) => {
                if(slide.classList.contains('current')) {
                    currentSlideNum = index + 1;
                    return;
                }
            });

            slideCounterElement.innerHTML = currentSlideNum + '/' + totalSlideNum;
        });

        lightbox.on('close', () => {
            document.querySelector('.js-cursor').classList.remove('opacity-0');
        });
    }
}

function drawSVG() {
    anime({
        targets: '.draw path',
        strokeDashoffset: [anime.setDashoffset, 0],
        easing: 'easeOutSine',
        duration: 1000,
        delay: function(el, i) { return i * 250 },
        direction: 'alternate',
        loop: false
      });
}

function animateSVGStroke(svgElement, offset, duration) {

    if(!offset) {
        offset = 0;
    }

    if (!duration) {
        duration = 500;
    }

    anime({
        targets: svgElement.querySelector('path'),
        strokeDashoffset: [anime.setDashoffset, offset],
        easing: 'linear',
        duration: duration,
        delay: function (el, i) { return i * 250 },
        direction: 'alternate',
        loop: false
    });
}

function footerAsterixAnimTrigger() {
    let asterixContainer = document.querySelector('.footer-asterix-container');
    asterixContainer.addEventListener('mouseover', () => {
        anime({
            targets: asterixContainer.querySelector('.footer-asterix path'),
            strokeDashoffset: [anime.setDashoffset, 0],
            easing: 'easeOutSine',
            duration: 1000,
            delay: function (el, i) { return i * 250 },
            direction: 'alternate',
            loop: false
        });
    });
}

function footerGetInTouchAnimTrigger() {
    let getInTouchContainer = document.querySelector('footer .get-in-touch');

    if(getInTouchContainer) {
        getInTouchContainer.addEventListener('mouseover', () => {
            anime({
                targets: getInTouchContainer.querySelector('footer .get-in-touch svg path'),
                strokeDashoffset: [anime.setDashoffset, 0],
                easing: 'easeOutSine',
                duration: 1000,
                delay: function (el, i) { return i * 250 },
                direction: 'alternate',
                loop: false
            });
        });
    }
}

function teamNamer() {
    let teamNames = document.querySelectorAll('.team-name-button');
    let toggleButton = document.querySelectorAll('.team-toggle-btn');

    if(toggleButton) {
        toggleButton.forEach((button) => {
            button.addEventListener('mouseover', () => {
                document.querySelector('.js-cursor').classList.add('opacity-0');
            });

            button.addEventListener('mouseleave', () => {
                document.querySelector('.js-cursor').classList.remove('opacity-0');
            });
        })
    }

}

function homeLoader (){
    let animationWrapper = document.querySelector('.logo-animation-wrapper');
    let animationInner = document.querySelector('.logo-animation-inner');
    
    if(animationWrapper){
        let offsetTop = animationInner.offsetTop;
        let offsetLeft = animationInner.offsetLeft;

        let animationX = document.querySelectorAll('.logo-animation-inner--x');
        let animationY = document.querySelectorAll('.logo-animation-inner--y');

        animationX.forEach((el) => {
            el.style.width = `${offsetLeft}px`;
        });
        animationY.forEach((el) => {
            el.style.height = offsetTop + 1 + 'px';
        });

    }

    // x-init="$nextTick(() => { $refs.searchInput.style.left = `${$refs.searchInput.offsetLeft}px` });"

    if (animationWrapper && window.homeAnimationComplete) {
        animationWrapper.classList.add('finished');
    }

    if(animationWrapper && !window.homeAnimationComplete) {

        animationWrapper.addEventListener('click', () => {
            window.homeAnimationComplete = true;
            animationWrapper.classList.add('finished');
        });


        window.setTimeout(() => {

            var tl = anime.timeline({
                easing: 'linear',
            });

            tl
            .add({
                targets: '.logo-animation path',
                strokeDashoffset: [anime.setDashoffset, 0],
                easing: 'linear',
                duration: 2500,
                delay: function(el, i) { return i * 250 },
                direction: 'alternate',
                loop: false,
                begin: function() {
                    document.querySelector('#mask-filler').classList.add('ready');
                },
                complete: function(anim) {
                    if (document.querySelector('.logo-animation-wrapper')) {
                        window.homeAnimationComplete = true;
                        document.querySelector('.logo-animation-wrapper').classList.add('finished');
                    }
                }
            })
        }, 1000)
    }
}

function footerLoader() {
    var tl = anime.timeline({
        easing: 'cubicBezier(.5, .05, .1, .3)',
    });

    tl.add({
        targets: 'footer svg path',
        strokeDashoffset: [anime.setDashoffset, 0],
        easing: 'cubicBezier(.5, .05, .1, .3)',
        duration: 800,
        delay: function (el, i) { return i * 250 },
        direction: 'alternate',
        loop: false
    });
}

function customCursor() {
    var cursor = select('.js-cursor');
    var pointer = select('.cursor');

    document.addEventListener('mousemove', t => {
        var curX = t.clientX;
        var curY = t.clientY;
        cursor.classList.add('!md:block');
        cursor.style.transform =
            'translate(calc(' + curX + 'px - 50%),calc(' + curY + 'px - 50%))';
    });

    document.addEventListener('mouseleave', () => {
        cursor.classList.remove('!block');
    });

    // select('.link').addEventListener('mouseover', () => {
    //     cursor.classList.add('!opacity-0');
    //     console.log('link hovered');
    // });

    // select('.js-cursor-white').addEventListener('mouseover', () => {
    //     pointer.classList.add('!bg-white');
    //     console.log('link hovered');
    // });

    // select('.js-cursor-white').addEventListener('mouseleave', () => {
    //     pointer.classList.remove('!bg-white');
    //     console.log('link hovered');
    // });

}


// swup.on('contentReplaced', underlineLinks);


// function homeSlider(){
//     const swiper = new Swiper('.js-home-slider', {
//         autoplay: {
//             delay: 4000,
//         },
//         effect: 'fade',
//         fadeEffect: {
//             crossFade: true
//         },
//         speed: 1000,
//         loop: true
//       });
// }

// window.app = function scrollRotate() {
//     let image = document.getElementById("brandmark");
//     image.style.transform = "rotate(" + window.pageYOffset/5 + "deg)";
// }

function underlineLinks(){
    // var underlines = document.querySelectorAll(".project-underline-svg, .project-outline-svg");
    // var i;

    // for (i = 0; i < underlines.length; i++) {

    //     var path = underlines[i].querySelector('.project-underline-svg__path');

    //     if(underlines[i].classList.contains('project-outline-svg')){
    //         path.setAttribute("stroke-dasharray", path.getTotalLength() / 2);
    //         path.setAttribute("stroke-dashoffset", 30);
    //     } else {
    //         path.setAttribute("stroke-dasharray", path.getTotalLength());
    //         path.setAttribute("stroke-dashoffset", path.getTotalLength() * 0.25);
    //     }
    // }
}
